import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ModalCustom from './../../components/common/modalCustom/modalCustom';
import CardNationalId from './nationa_id/nationa_id';

const useStyles = makeStyles((theme) => ({

}));


export default function TransitionsModal({ open, setOpen, setFlagRegister, setFlagNotif }) {

    const classes = useStyles();

    return (
        < ModalCustom
            open={open}
            onClose={() => setOpen(false)}
            className={classes['modal']}
        >
            <CardNationalId
                setFlagRegister={setFlagRegister}
                onClose={() => setOpen(false)}
                setFlagNotif={setFlagNotif}
            />
        </ModalCustom >
    );
}
